<template>
  <div>
    <page-header
      icon="mdi-bullhorn-outline"
      :title="$t('marketing')"
      :subtitle="$t('marketing_page_subtitle')"
    />
    <div class="marketing-body">
      <div class="marketing-content">
        <finance-tab-promotions />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/global/PageHeader.vue";
import { FinanceTabPromotions } from "@/components/restaurant/finance";

// Promocije su izdvojene iz finansija u meni "Marketing". Njihov finansijski efekat
// se u Obračunima pojavljuje kao odbitak kad backend dobije PROMO_DISCOUNT.
// Isti vizuelni okvir kao Finansije: sivo polje, centriran sadržaj, bijele kartice.
export default {
  name: "RestaurantMarketing",

  components: { PageHeader, FinanceTabPromotions },
};
</script>

<style>
.marketing-body {
  background: #f6f6f4;
  min-height: 70vh;
  border-top: 1px solid #e6e8ec;
}

.marketing-content {
  max-width: 1480px;
  margin: 0 auto;
  padding: 24px 24px 48px;
}

.marketing-body .v-card--outlined {
  border-radius: 12px;
  border-color: #e9e9e6;
  background: #fff;
}

@media (max-width: 600px) {
  .marketing-content {
    padding: 16px 12px 32px;
  }
}
</style>
